import Cookies from 'js-cookie';
import { LEASE_ACCESS_TOKEN } from '../constants/constants';

const checkHasLeaseAccess = async () => {
  const hasAccess = await Cookies.getJSON(LEASE_ACCESS_TOKEN);
  return hasAccess || false;
};

export default checkHasLeaseAccess;
